import { render } from "./MovimentacaoCommonView.vue?vue&type=template&id=457d9eea"
import script from "./MovimentacaoCommonView.vue?vue&type=script&lang=js"
export * from "./MovimentacaoCommonView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__